const Backbone = require('lib/backbone')
const Element = require('./element')

const ElementList = Backbone.Collection.extend({

    model: Element,

    initialize(models, options = {}) {
        this.setRelatedModel(options.related_model)
    },

    setRelatedModel(model) {
        if (this.related_model === model) return
        this.related_model = model
        this.trigger('change:related_model', this, model)
    },

})

module.exports = ElementList
